module.exports = __webpack_public_path__ + "img/1f99d.03bb07c.svg";